<template>
  <div
    class="content-filters full-width
    bg-grey-20 center-v"
  >
    <div class="container vertical-align-super">
      <div class="flex-row">
        <div class="flex-start">
          <tr-button
            v-if="hasButton && shouldShowButtonForRole"
            :dropdown="$slots.mainButtonDropdownOptions"
            :hide-caret="true"
            :open-dropdown-on-hover="$slots.mainButtonDropdownOptions"
            :label="title"
            :on-button-click="onAddClick"
            svg-href="ic-add-circle"
          >
            <slot name="mainButtonDropdownOptions" />
          </tr-button>
          <tr-typography
            v-else
            variant="h3"
          >
            {{ title }}
          </tr-typography>
        </div>
        <slot name="left-filter" />
        <slot name="center-filter" />
        <slot name="right-filter" />
        <tr-form
          v-if="onSearch"
          classes="flex-end"
          name="searchForm"
          :on-valid-submit="onSearch.bind(undefined, searchTerm)"
        >
          <tr-text-field
            v-model="searchTerm"
            name="search"
            classes="col-lg-12"
            no-margin="true"
            :placeholder="searchPlaceholder"
            input-search="true"
          />
        </tr-form>
      </div>
    </div>
  </div>
</template>

<script>
import TrForm from './TrForm.vue';
import TrTextField from './TrTextField.vue';
import TrButton from './TrButton.vue';
import TrTypography from './TrTypography.vue';
import verifyRoleAccess from '../services/verifyRoleAccess';

export default {
  name: 'TrPageHeader',
  components: {
    TrForm,
    TrTextField,
    TrButton,
    TrTypography
  },
  props: {
    title: {
      required: true,
      type: String
    },
    onAddClick: {
      required: false,
      type: Function
    },
    searchPlaceholder: {
      required: false,
      type: String
    },
    onSearch: {
      required: false,
      type: Function
    },
    hideButtonForRoles: {
      required: false,
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    searchTerm: ''
  }),
  computed: {
    hasButton() {
      return Boolean(this.onAddClick || this.$slots.mainButtonDropdownOptions);
    },
    shouldShowButtonForRole() {
      if (this.hideButtonForRoles) {
        return !verifyRoleAccess.isLoggedUserForbiddenToAccess(this.hideButtonForRoles);
      }
      return true;
    }
  }
};
</script>
